import type { MedVisitCitation } from "@/services/medChronServiceV2.types";

export interface MedVisitDetail {
  visit_detail_category: string;
  visit_details: string;
}

export interface MedVisitDetailResponse {
  visit_detail_category: string;
  visit_details: string;
  order_id: number;
}

export interface MedVisit {
  version_id: string;
  visit_id: string;
  visit_date?: string | null;
  visit_type_id: string;
  provider_name?: string | null;
  facility_name?: string | null;
  visit_subtype?: string | null;
  citations: MedVisitCitation[];
  med_visit_details: MedVisitDetailResponse[];
  source_version_id?: string | null;
}

export interface MedPatientBackground {
  prior_medical_history?: string | null;
  pre_existing_conditions?: string | null;
  family_history?: string | null;
  social_history?: string | null;
  allergies_medications?: string | null;
}

/** Keys for patient background blocks edited on the chronology summary tab (single source of truth). */
export const MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS = [
  "prior_medical_history",
  "pre_existing_conditions",
  "family_history",
  "social_history",
  "allergies_medications",
] as const;

export type MedPatientBackgroundUpdate = Partial<MedPatientBackground>;

export interface MedVisitBulkUpdatePatch {
  visit_type_id?: string;
  provider_name?: string;
  facility_name?: string;
  visit_subtype?: string;
  /** Replaces each visit's whole list; an empty array clears it. */
  citations?: MedVisitCitation[];
}

export interface MedVisitBulkUpdateRequest {
  visit_ids: string[];
  patch: MedVisitBulkUpdatePatch;
}

export interface MedVisitBulkDeleteRequest {
  visit_ids: string[];
}

export interface MedVisitBulkCopyRequest {
  visit_ids: string[];
}
